var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"race-clock",class:[_vm.sizeClass, _vm.boxClass, _vm.stateClass]},[(_vm.dayCount > 0)?_c('span',{staticClass:"race-clock__days"},[_vm._v(_vm._s(_vm.dayCount)+"d")]):_vm._e(),(_vm.hasTimePart)?_c('datetime',{attrs:{"dt":_vm.timePart,"format":"HH:mm:ss","milliseconds":1}}):_c('span',[_vm._v("--:--:--")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }